import { useEffect, useRef, useState } from "react";


// Bugfix for dropdown width issue in mobile view - V2OGLASI-1593
export const useDropdownBugfix = (groupConfigsLength: number) => {
  const [maxWidth, setMaxWidth] = useState(undefined);
  const divRef = useRef(null);

  const handleResize = () => {
    if (!divRef.current) return;

    const rect = divRef.current.getBoundingClientRect();
    if (!rect.width) return;
    setMaxWidth(rect.width);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [groupConfigsLength]);

  return { maxWidth, divRef };
}


// WEBPACK FOOTER //
// ./src/containers/ModulePage/SubLevel1/SubLevel1Desktop/FilterSection/SearchControls/SearchGroups/hooks/useDropdownBugfix.ts